export { default as en } from './en';
export { default as ko } from './ko';
export type { Translations } from './en';
